import React from "react";
import { BellRing } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export function ProximityToggle({ value, onChange }) {
  return (
    <div data-testid="proximity-toggle-row" className="flex items-center gap-3 bg-emerald-50 border border-emerald-100 rounded-2xl p-3">
      <span className="w-9 h-9 rounded-full bg-white text-emerald-600 flex items-center justify-center shrink-0"><BellRing className="w-4 h-4" /></span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-slate-900">Njofto njerëzit afër</p>
        <p className="text-xs text-slate-500">Kush kalon afër biznesit merr njoftim “… është afër teje”</p>
      </div>
      <Switch data-testid="proximity-toggle" checked={value} onCheckedChange={onChange} />
    </div>
  );
}
